import { BulbOutlined, FileWordOutlined, GlobalOutlined, PictureOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from 'src/web/Utils/trackEvent';
import styled from 'styled-components';

const Section = styled.section`
  padding: 60px 0;
  background-color: #ffffff;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #00296b;
  margin-bottom: 2rem;
`;

const CategoryList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  li {
    flex: 1 1 calc(50% - 10px);
    background-color: #f8f9fc;
    padding: 16px 20px;
    border-radius: 10px;
    font-weight: 500;
    color: #003366;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease;

    &:hover {
      background-color: #eaf4ff;
      transform: translateY(-2px);
    }

    .icon {
      margin-right: 12px;
      font-size: 20px;
      color: #1890ff;
    }
  }

  @media (min-width: 768px) {
    li {
      flex: 1 1 calc(25% - 15px);
    }
  }
`;

export default function KategoriKelas() {
  return (
    <Section>
      <div className="container px-3 px-md-4 px-lg-5">
        <Title>Temukan Kelas Sesuai Minatmu</Title>
        <CategoryList>
          <li>
            <GlobalOutlined className="icon" />
            Language Skill
          </li>
          <li>
            <BulbOutlined className="icon" />
            Digital Marketing
          </li>
          <li>
            <FileWordOutlined className="icon" />
            Microsoft Office Mastery
          </li>
          <li>
            <PictureOutlined className="icon" />
            Creative & Design
          </li>
        </CategoryList>

        <div className="text-center">
          <Link to="/courses">
            <button
              className="btn btn-pink px-4 py-2"
              onClick={() => {
                trackEvent({
                  eventName: 'button_click_lihat_semua_kelas',
                  params: { item_category: 'mesx' },
                });
              }}
            >
              Lihat Semua Kelas
            </button>
          </Link>
        </div>
      </div>
    </Section>
  );
}
